import { render } from "./MetricWithChange.vue?vue&type=template&id=a4b56bae"
import script from "./MetricWithChange.vue?vue&type=script&lang=js"
export * from "./MetricWithChange.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__